import axios from '../../plugins/axios.js';

export default{
    async getUserRoleSummary() {
        return await axios.get('/api/User/GetUserToRoleSummary');
    },
    async getTazUserRoles() {
        return await axios.get('/api/User/GetUserRoles');
    },
    async deleteUserRole(userRoleData) {
        return await axios.post('/api/User/DeleteUserFromRole', userRoleData);
    },
    async saveUserToRole(userRoleData) {
        return await axios.post('/api/User/SaveUserToRole', userRoleData);
    }
}